import axios from "axios";
import EnvironmentService from "@/services/EnvironmentService";
import {RMDNotificationResponse} from "@/services/types/RMDNotificationResponse";
import {rmdNotifications} from "@/store/rmd-notification.store";

class RMDNotificationService {

  constructor() {
  }

  loadNotifications() {
    return axios.get<RMDNotificationResponse>(EnvironmentService.applicationConfiguration.bookingServiceBaseUrl + "ContentManager/RMDNotification").then(response => {
      rmdNotifications.cache.message_DE = response.data.message_DE;
      rmdNotifications.cache.message_PL = response.data.message_PL;
      rmdNotifications.cache.message_CZ = response.data.message_CZ;
      rmdNotifications.cache.from = response.data.from;
      rmdNotifications.cache.to = response.data.to;
    });
  }
}

const rmdNotificationService = new RMDNotificationService();
const loadRMDNotification = () => rmdNotificationService.loadNotifications();

export {loadRMDNotification};
